// The planning tables' closed vocabularies, read by the request schemas and the
// tables' CHECK constraints alike. No imports: the schema reads this file.

export const CALENDAR_KINDS = ["personal", "finance", "holidays", "other"] as const;

/** Who made a calendar or an event: the person, an import, or the application. */
export const ENTITY_SOURCES = ["manual", "imported", "system"] as const;

export const TASK_STATUSES = ["open", "done", "archived", "deleted"] as const;

export const TASK_PRIORITIES = ["low", "normal", "high"] as const;
